(function () {
    'use strict';

    angular
        .module('riskEventEditModule')
        .controller('RiskEventEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'topBarService', 'grcRiskEventService', 'permissionService', 'riskEvent'];

    function Controller($scope, $state, $stateParams, topBarService, grcRiskEventService, permissionService, riskEvent) {

        topBarService.setTitleAndIcon('Manage Risk Events', 'fa fa-newspaper-o');

        $scope.ctrlCtxt = {};

        if (_.isUndefined(riskEvent) || !_.isObject(riskEvent)) {
            $state.go('riskEventNotExists', { RiskID: $stateParams.RiskEventID });
            return;
        }

        // Risk Event
        $scope.ctrlCtxt.riskEvent = riskEvent;
        $scope.goToRiskEvent = function (item) {
            $state.go('riskEventEdit', { RiskEventID: item.RiskEventID });
        };

        // Related Risks 
        $scope.getRelatedRisks = function (item) {
            if (_.isUndefined(item.RiskEventID)) return;
            return grcRiskEventService.getRelatedRisks(item.RiskEventID);
        };

        $scope.goToRelatedRisks = function () {
            $state.go('riskEventEdit.RelatedRisks');
        };

        $scope.showRelatedRisks = function () {
            if (!$scope.ctrlCtxt.riskEvent.RiskEventID) return false;
            if ($scope.ctrlCtxt.riskEvent.IsClosed) return false;

            return permissionService.hasPermission('GRCRiskManagement', 'RiskEventAssociation', 'View');;
        }
    }
})();